import { computed } from 'vue'
import { BaseProps } from '@/models/types/BaseProps'

export const useBaseProps = (props: BaseProps) => {
  const propClasses = computed(() => [
    {
      [`text-${props.alignment}`]: props.alignment,
      'g-row w-100': props.container,
      'd-grid': props.grid,
      'd-flex': props.flex,
      [`col-${props.col}`]: props.col,
      [`col-sm-${props.sm}`]: props.sm,
      [`col-md-${props.md}`]: props.md,
      [`col-lg-${props.lg}`]: props.lg,
      [`col-xl-${props.xl}`]: props.xl,
      'ly-wrap': props.wrap,
      [`ly-${props.direction}`]: props.direction,
      'ly-even': props.even && !props.container,
      [`ly-even-${props.evenItems}`]: props.evenItems && !props.container,
      'ly-grow': props.grow,
      'ly-shrink': props.shrink,
      [`ly-${props.alignH || 'start'}-${props.alignV || 'start'}`]:
        props.alignH || props.alignV,
      'ly-no-gap': props.noGap,
      [`p-${props.padding}`]: props.padding,
      [`pt-${props.paddingTop}`]: props.paddingTop,
      [`pb-${props.paddingBottom}`]: props.paddingBottom,
      [`pr-${props.paddingRight}`]: props.paddingRight,
      [`pl-${props.paddingLeft}`]: props.paddingLeft,
      [`m-${props.margin}`]: props.margin,
      [`mt-${props.marginTop}`]: props.marginTop,
      [`mb-${props.marginBottom}`]: props.marginBottom,
      [`mr-${props.marginRight}`]: props.marginRight,
      [`ml-${props.marginLeft}`]: props.marginLeft,
      rounded: props.rounded,
      'rounded-sm': props.roundedSm,
      'rounded-lg': props.roundedLg,
      'rounded-full': props.roundedFull,
      shadow: props.shadow,
      'shadow-lg': props.shadowLg,
      border: props.border,
      [`border-${props.borderColor}`]: props.borderColor,
      [`border-top`]: props.borderTop,
      [`border-right`]: props.borderRight,
      [`border-bottom`]: props.borderBottom,
      [`border-left`]: props.borderLeft,
      [`text-${props.color}`]: props.color,
      [`bg-${props.bg}`]: props.bg,
      [`w-${props.width}`]: props.width,
    },
  ])

  return {
    propClasses,
  }
}
